'use strict';

var React = require('react');
var AviaryThemeContext = require('../AviaryThemeContext.cjs');

/**
 * Used to access and set the Aviary theme
 */ const useAviaryTheme = ()=>{
    return React.useContext(AviaryThemeContext.AviaryThemeContext);
};

exports.useAviaryTheme = useAviaryTheme;
//# sourceMappingURL=useAviaryTheme.cjs.map
